const paymentVoucher = {
  path: 'paymentVoucher/:studentRegistrantsId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/paymentVoucher'], resolve)
}
export default paymentVoucher



// WEBPACK FOOTER //
// ./src/router/pages/student_user/paymentVoucher/index.js